module.exports = __webpack_public_path__ + "img/Support-skill-222.6dd5756a.png";